/*
 * @Author: Ashley.Liu
 * @Date: 2022-05-10 16:13:24
 * @LastEditTime: 2022-07-07 14:35:14
 * @Description: desc
 */
import Vue from 'vue'
let errorCount = 5
export default function (clickCallback, err) {
  if (err.code === 'ECONNABORTED' && err?.message?.indexOf('timeout') !== -1) {
    Vue.prototype.$notify.warning({
      title: 'Refresh Tips',
      customClass: 'zm-notification--warning',
      message: 'This is a error with loading dictionary data, Will reload after 5 seconds!',
      duration: 5000,
      onClose: () => {
        if (errorCount > 0) {
          errorCount--
          clickCallback()
        }
      },
      offset: 60
    })
  } else {
    Vue.prototype.$notify.warning({
      title: 'Refresh Tips',
      customClass: 'zm-notification--warning',
      message: 'This is a error with loading dictionary data, please refresh to try again!',
      duration: 5000,
      offset: 60
    })
  }
}
